<template>
    <div :class="wrapperClass">
        <KvTypography v-if="resolvedFieldName" color="primary" size="medium" weight="medium">
            {{ resolvedFieldName }}
        </KvTypography>

        <KvSelect v-if="resolvedType === 'user'" class="w-100" v-model="v" :options="field.options" :size="size" :placeholder="t('custom_fields-select_user')">

        </KvSelect>

        <datetime v-else-if="field.type === 'date'" type="date" :flow="['year', 'month', 'date']" value-zone="America/Sao_Paulo" v-model="v"></datetime>

        <KvInput v-else :size="size" type="text" v-model="v" />
    </div>
</template>
<script>
import { mapState } from "vuex";
import KvInput from "../inputs/kv-input.vue";
import KvTypography from "../ui/kv-typography.vue";
import KvSelect from "../inputs/kv-select.vue";
import { Datetime } from "vue-datetime";

export default {
    name: "kv-custom-field",
    props: {
        field: {
            type: Object,
            default: () => ({})
        },
        value: {
            type: null,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        fieldName: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: "regular"
        },
        wrapperClass: {
            type: [String, Array, Object],
            default: () => 'd-flex flex-column flex-1 gap-sm'
        }
    },

    components: {
        KvInput,
        KvTypography,
        KvSelect,
        Datetime
    },
    computed: {
        ...mapState({
            users: (state) => state.users,
        }),

        resolvedType() {
            return this.type ?? this.field.type
        },

        resolvedFieldName() {
            return this.fieldName ?? this.field.field_name
        }
    },
    data() {
        return {
            v: this.value,
        };
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
    watch: {
        v() {
            this.$emit("input", this.v);
        },
        value() {
            if (this.value !== this.v) {
                this.v = this.value;
            }
        },
    },
};
</script>
